export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: "short-video",
    name: "短视频运营",
    description: "深耕短视频内容创作与流量运营，从策略规划到执行落地，助力品牌在抖音、快手等平台实现爆发式增长",
    icon: "ri-vidicon-line",
    articleCount: 2
  },
  {
    slug: "social-media",
    name: "社交媒体营销",
    description: "覆盖微信、微博、小红书、B站等主流社交平台，提供从内容策划到用户运营的全链路营销服务",
    icon: "ri-share-line",
    articleCount: 3
  },
  {
    slug: "creative",
    name: "创意制作",
    description: "汇聚行业顶尖创意人才，提供品牌宣传片、产品视频、动画制作等高品质视觉内容创作服务",
    icon: "ri-movie-line",
    articleCount: 2
  },
  {
    slug: "branding",
    name: "品牌传播",
    description: "从品牌定位到传播策略，从内容矩阵到效果评估，为品牌构建系统化的全域传播体系",
    icon: "ri-global-line",
    articleCount: 1
  },
  {
    slug: "new-media",
    name: "新媒体运营",
    description: "提供新媒体团队搭建、账号运营、数据分析等一站式服务，帮助品牌建立专业的内容运营能力",
    icon: "ri-smartphone-line",
    articleCount: 1
  }
];